import { Card } from 'antd';
import { NotificationSettings } from '../../components/profile/NotificationSettings';
import { PageHeader, PageContainer, DevFilePathBadge } from '../../components/common';

export default function NotificationSettingsPage() {
  return (
    <PageContainer>
      <DevFilePathBadge filePath="client/src/pages/settings/NotificationSettingsPage.tsx" />
      <PageHeader
        title="通知設定"
        subtitle="通知の受信設定を管理します"
      />
      <Card>
        <NotificationSettings />
      </Card>
    </PageContainer>
  );
}
